export default __webpack_public_path__ + "2daa475fc18b1bdbfc002293aff6b6d7.png";